module.exports = __webpack_public_path__ + "resources/img/img-vormetric-encryption-m.a4263dc96afe55748286208ef1bad601.png";